import { render, staticRenderFns } from "./msgbox.vue?vue&type=template&id=3da80492&"
import script from "./msgbox.vue?vue&type=script&lang=js&"
export * from "./msgbox.vue?vue&type=script&lang=js&"
import style0 from "./msgbox.vue?vue&type=style&index=0&id=3da80492&prod&lang=scss&"
import style1 from "./msgbox.vue?vue&type=style&index=1&id=3da80492&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports